export const profile = {
  name: 'Bruno Oliveira',
  brand: 'Crânio da Tecnologia',
  roles: ['Apps Android', 'Sites e sistemas web', 'Jogos mobile e web', 'Integrações com Firebase'],
  email: 'craniodatecnologia@gmail.com',
  whatsapp: 'https://wa.me/5543996077691',
  playStore: 'https://play.google.com/store/apps/dev?id=9164323135708807953',
  github: 'https://github.com/craniodatecnologia',
  linkedin: 'https://www.linkedin.com/in/brunoaoliveiradev',
  instagram: 'https://www.instagram.com/brunoaoliveira.dev',
};

export const whatsappMessage = (text: string) => `${profile.whatsapp}?text=${encodeURIComponent(text)}`;

export const skillGroups = [
  { title: 'Mobile', items: ['Kotlin', 'Jetpack Compose', 'Android', 'MVVM', 'AdMob'] },
  { title: 'Web', items: ['React', 'Next.js', 'TypeScript', 'JavaScript', 'Tailwind CSS'] },
  { title: 'Backend & Dados', items: ['Firebase Auth', 'Firestore', 'Realtime Database', 'Cloud Functions', 'Node.js'] },
  { title: 'Ferramentas', items: ['Git & GitHub', 'Google Play Console', 'Firebase Hosting', 'PostgreSQL'] },
];

export const services = [
  { icon: 'phone', title: 'Aplicativos Android', text: 'Apps nativos em Kotlin e Jetpack Compose, da ideia à publicação na Google Play, com login, banco em nuvem e monetização.' },
  { icon: 'globe', title: 'Sites e sistemas web', text: 'Sites institucionais, portais e sistemas sob medida com React e Next.js, rápidos, responsivos e prontos para o Google.' },
  { icon: 'gamepad', title: 'Jogos', text: 'Jogos mobile e web com ranking online, progresso salvo na nuvem e desafios diários.' },
  { icon: 'cloud', title: 'Firebase & integrações', text: 'Autenticação, Firestore, regras de segurança, hospedagem e funções serverless integrados ao seu produto.' },
];

export const projects = [
  { title: 'BruninhoJogos', text: 'Portal de puzzles diários com Sudoku, Termo, Caça-palavras, Cruzadinha e mais, com ranking e login Google.', tags: ['Next.js', 'Firebase', 'Cloud Functions'] },
  { title: 'Comunidade SAP', text: 'Portal comunitário de cidade: eventos, notícias, vagas, transporte e gastronomia, com painel administrativo completo.', tags: ['Next.js', 'Firestore', 'Auth'] },
  { title: 'Convites digitais', text: 'Plataforma multi-evento: o cliente cria o convite, personaliza o tema e compartilha uma página pública do evento.', tags: ['Next.js', 'Pix', 'Google Auth'] },
  { title: 'Plataforma para clínicas', text: 'Sistema multiempresa com agenda, bloqueio de conflitos de horário, equipe e área pública para pacientes.', tags: ['Multi-tenant', 'Firestore', 'Tailwind'] },
];
